// extracted by mini-css-extract-plugin
export default {"preloader_item":"LoaderTopicList_preloader_item__wGhSi","topic_item":"LoaderTopicList_topic_item__k9ufo","skeleton-loading":"LoaderTopicList_skeleton-loading__WaWVr"};